import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import Container from '../../components/Layout/Container';
import PageTopBanner from '../../components/PageTopBanner';

import { TabsLink } from '../../components/Tab/Tabs';
import { programData } from '../../components/Tab/TabData';

import Input from '../../components/TextField/Input';
import { Button, PageControlBtns } from '../../components/Button/Button';

import { fetchPostWithFiles } from '../../hooks/fetch';
import { handlePhone, validateEmail, validateName, validatePhone, validateStr } from '../../hooks/useValidate';
import useFiles from '../../hooks/useFiles';

export default function ProgramApply() {
	const [activeTab, setActiveTab] = useState('');

	const handleDataFromChild = (data) => {
		setActiveTab(data);
	};

	const pageName = '프로그램 신청';

	const navigate = useNavigate();
	const location = useLocation();
	const { id, title, summary } = location.state || {};
	const [applyInfo, setApplyInfo] = useState({});
	const [files, handleFileChange, deleteFile, toFormData] = useFiles();

	const onChangeApplyInfo = (e) => {
		const { name, value } = e.target;
		setApplyInfo({
			...applyInfo,
			[name]: name === 'phone' ? handlePhone(value) : value
		})
	}

	const validate = () => {			
		return validateName(applyInfo.name)
			&& validatePhone(applyInfo.phone)
			&& validateEmail(applyInfo.email)
			&& validateStr(applyInfo.company, "소속을");
	}

	function apply(e) {
		e.preventDefault();
		if(!validate()) return;
		
		fetchPostWithFiles(
			`/programs/nonuser/${id}`,
			"프로그램을 신청",
			toFormData(applyInfo),
			() => {
				navigate(
					`/program/list/${id}`,
					{ state: location.state, replace: true }
				);
			}
		)
	}

	return (
		<main id="program-page-wrap">
			<h1 className="sr-only">{`${pageName} 페이지`}</h1>

			<PageTopBanner />

			<Container>
				<TabsLink
					className="sub-page-tab-con"
					tabsData={programData}
					activatedTab={activeTab}
					onTabChange={handleDataFromChild}
				/>

				<div className="page-content">
					<div className="content-top">
						<div>
							<h1 className="title">{pageName}</h1>
						</div>
					</div>

					<div>
						{title && summary ? (
							<div className="apply-form-wrap">
								<h2 className="gs-page-sub-title">신청하기</h2>
								<div className="detail-form-con">
									<div className="dv-header">
										<div className="gs-infos-badge">
											<div className="info-2 ta-center">
												<h2>{title}</h2>
												<p>{summary}</p>
											</div>
										</div>
									</div>
									<div className="dv-body">
										<Input.Group>
											<Input
												id="user-name"
												className="row"
												type="text"
												showLabel
												essential
												label="신청자"
												placeholder="신청자 입력"
												name="name"
												value={applyInfo.name}
												onChange={onChangeApplyInfo}
												maxLength={20}
											/>
											<Input
												id="user-tel"
												className="row"
												type="tel"
												showLabel
												essential
												label="휴대폰 번호"
												placeholder="휴대폰 번호 입력"
												maxLength={13}
												name="phone"
												value={applyInfo.phone}
												onChange={onChangeApplyInfo}
											/>
											<Input
												id="user-email"
												className="row"
												type="email"
												showLabel
												essential
												label="이메일"
												placeholder="이메일 입력"
												name="email"
												value={applyInfo.email}
												onChange={onChangeApplyInfo}
												maxLength={100}
											/>
											<Input
												id="user-affiliation"
												className="row"
												type="text"
												showLabel
												essential
												label="소속"
												placeholder="소속 입력"
												name="company"
												value={applyInfo.company}
												onChange={onChangeApplyInfo}
												maxLength={50}
											/>
											<div className="gs-file-wrap">
												<div className="label">첨부파일</div>
												<div className="gs-files-con">
													<div className="gs-file-upload">
														<input type="file" accept="" multiple={5} onChange={handleFileChange}/>
														<Button type="button" className="cyan" tabIndex={-1}>파일 업로드</Button>
													</div>
													<ul className="gs-files">
														{files !== undefined && files.map((f, i) => {
															return (
																<li key={i}>
																	<a
																		href={URL.createObjectURL(f)}
																		download={f.name}
																		role="button"
																		className="file gs-underline-item blue"
																	>
																		<span className="line">{f.name}</span>
																	</a>
																	<div className="controls">
																		<Button type="button" className="remove" title="삭제" onClick={() => deleteFile(i)}>
																			<span className="sr-only">삭제</span>
																		</Button>
																	</div>
																</li>
															);
														})}
													</ul>
												</div>
											</div>
										</Input.Group>
									</div>
								</div>
							</div>
						) : (
							<div className="gs-no-con">해당 프로그램을 찾을 수 없습니다.</div>
						)}
					</div>

					<PageControlBtns>
						<Link to={`./../../list/${id}`} state={location.state} className="gs-btn white">
							취소하기
						</Link>
						<Button onClick={apply}>신청하기</Button>
					</PageControlBtns>
				</div>
			</Container>
		</main>
	);
}
